import { _, helpers, React, ts, ui } from '_core';

import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  fullScreen: boolean;
  definition: ts.types.signal.Lasso;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, file, fullScreen, definition, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file,
        },
      });
      if (response) {
        setData(response.data);
      }
    } catch (err) {
      setError(JSON.stringify(err));
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    const formattedData = nestedBarChartFormat(data);
    return {
      ...formattedData,
      data: helpers.buildName.signalVarCategoryName(formattedData.data, definition) as ts.types.widgets.NestedBarData,
    };
  }, [data]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      category="category"
      numberFormat="#.##%"
      yAxisLabel="Percent Significance"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};

export default Chart;
